/**
 * Tenants where certain Analytics features (Productivity, AI Usage) must be
 * hidden (contract / customer requirement). Match on `user.primaryDomain`
 * (lowercased).
 */
const ANALYTICS_DISABLED_PRIMARY_DOMAINS = new Set(['synthesia.io'])

export const isAnalyticsDisabledForPrimaryDomain = (
  primaryDomain: string | undefined,
): boolean =>
  ANALYTICS_DISABLED_PRIMARY_DOMAINS.has((primaryDomain ?? '').toLowerCase())
